import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {Link} from "react-router-dom";
import Loading from "../../components/loading";
import {useTranslation} from "react-i18next";
import './index.css'
import NoData from "../../components/no-data";
import {LazyLoadImage} from "react-lazy-load-image-component";
import * as Millicast from "@millicast/sdk";
import {toast} from "react-toastify";
import InformationToast from "../../components/toast/InformationToast";
const Streams = () => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const {t, i18n} = useTranslation()

    useEffect(() => {
        associateServices.getStreamList({
            page: 1,
            limit: 20
        }).then(res => {
            setData(res?.data?.data || [])
            setLoading(false)
        })
    }, [])



    return (
        <div className="section section--first">


            <div className="container">

                <div className="row">
                    <div className="col-12">
                        <h1 className="section__title section__title--head">{t('streams.title', 'Streams')}</h1>
                    </div>
                </div>

                {

                    loading ? <Loading/> :
                        data?.length <= 0 ? <NoData desc={t('streams.empty')}/> :
                            <div className="game-card-list">
                                {
                                    data.map((stream, index) => (
                                        <Link
                                            to={`/stream/${stream?.id}`}
                                            className="game-card" key={index}>
                                            <div className="game-image-wrapper">
                                                <LazyLoadImage
                                                    height={'100%'}
                                                    width={'100%'}
                                                    effect="blur"
                                                    threshold="100"
                                                    className="game-image"
                                                    placeholderSrc={stream?.streamer?.image}
                                                    src={stream?.streamer?.image}
                                                />
                                            </div>

                                            <div className="game-content">
                                                <h3 className="game-title one-line-ellipsis text-center">{stream?.streamer?.name}</h3>
                                            </div>
                                        </Link>
                                    ))
                                }
                            </div>
                }

            </div>
        </div>


    )

}

export default Streams
